module.exports = __webpack_public_path__ + "img/profile.f2cce1db.jpg";